"use client";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function WafraToast({ rtl }: { rtl: boolean }) {
  return (
    <ToastContainer
      position="top-center"
      autoClose={4000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={rtl}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      toastClassName={() =>
        "text-white bg-[var(--color-olive-dark)] shadow-lg rounded-xl px-4 py-3 text-sm font-medium"
      }
      bodyClassName={() => "flex items-center "}
      progressClassName="bg-green-500"
    />
  );
}
